import { ROOT_NAVIGATION, PATH_USER } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';
import { TFunction } from 'react-i18next';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/images/icons/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_banking'),
  payments: getIcon('ic_payments'),
  forms: getIcon('ic_forms'),
  transaction: getIcon('ic_transaction'),
  product: getIcon('ic-product'),
  coupon: getIcon('ic-coupon'),
};

const navConfig = (
  portalId: string,
  t: TFunction<'translation', undefined>
) => [
  {
    subheader: t('general'),
    items: [
      {
        title: t('dashboard'),
        path: ROOT_NAVIGATION.general.home(portalId),
        icon: ICONS.analytics,
      },
      {
        title: t('forms'),
        path: ROOT_NAVIGATION.general.forms(portalId),
        icon: ICONS.forms,
      },
      {
        title: t('products'),
        path: ROOT_NAVIGATION.general.products(portalId),
        icon: ICONS.product,
      },
      {
        title: t('coupons'),
        path: ROOT_NAVIGATION.general.coupons(portalId),
        icon: ICONS.coupon,
      },
      {
        title: t('quotes'),
        path: ROOT_NAVIGATION.general.quotes(portalId),
        icon: <RequestQuoteIcon />,
      },
      {
        title: t('form_submission'),
        path: ROOT_NAVIGATION.general.formSubmission(portalId),
        icon: ICONS.invoice,
      },
      {
        title: t('transactions'),
        path: ROOT_NAVIGATION.general.transactions(portalId),
        icon: ICONS.transaction,
      },
    ],
  },
  {
    subheader: t('manage'),
    items: [
      {
        title: t('gateways'),
        path: ROOT_NAVIGATION.general.gateways(portalId),
        icon: ICONS.dashboard,
      },
      {
        title: t('payment'),
        path: PATH_USER.payments.payments(portalId),
        icon: ICONS.payments,
      },
      {
        title: t('user_accounts'),
        path: PATH_USER.general.accountSettings(portalId, 'general'),
        icon: ICONS.user,
      },
    ],
  },
];

export default navConfig;
